<template>
    <div>
        <div @click="back" class="header">
            <i class="iconfont">&#xe604;</i>
        </div>
        <div class="settle">
            <input class="border" type="text" placeholder="请输入要结算的金额" v-model="price">
            <button @click="handleAllSettle">全部结算</button>
            <p>到账时间：<span>15日内到帐</span></p>
        </div>
        <div class="info">
            <div>
                <span>联系人</span>
                <input type="text" placeholder="请输入联系人姓名" v-model="name">
            </div>
            <div>
                <span>联系电话</span>
                <input type="text" placeholder="请输入联系电话" v-model="tel">
            </div>
            <div>
                <span>支付密码</span>
                <input type="password" placeholder="请输入支付密码" v-model="password">
            </div>
            <button @click="handleSubmitClick">提交</button>
        </div>
    </div>
</template>

<script>
export default {
  name: 'SettleList',
  data () {
    return {
      price: '',
      name: '',
      tel: '',
      password: ''
    }
  },
  methods: {
    back () {
      this.$router.go(-1) // 返回上一层
    },
    handleAllSettle () {
      this.price = this.$route.query.availamount
    },
    handleSubmitClick () {
      this.axios.get('/ApiMySettleList/PostApplySettle', {
        params: {
          trueName: this.name,
          tel: this.tel,
          paypassword: this.password,
          applyAmount: this.price
        }
      }).then(this.handleSubmitSuccClick)
        .catch(this.handleSubmitFailClick)
    },
    handleSubmitSuccClick (res) {
      res = res.data
      if (res.okInfo === 'succeed') {
        alert('已成功申请结算')
        this.$router.push({
          path: '/checklist'
        })
      } else {
        alert(res.errorInfo)
        if (res.errorInfo.indexOf('结算') >= 0) {
          if (res.errorInfo.indexOf('结算金额') >= 0) {
            this.$router.push({
              path: ''
            })
          } else {
            this.$router.push({
              path: '/checklist'
            })
          }
        }
      }
    },
    handleSubmitFailClick () {
      alert('提交失败')
      this.$router.push({
        path: '/checklist'
      })
    }
  }
}
</script>

<style scoped>
.header{ padding: 10px 15px; padding-bottom: 5px; border-bottom: 5px solid #eff3f6;}
.header .iconfont{ font-size: 25px;}
.settle{ margin: 30px 0;}
.settle input{ width: 80%; display: block; margin: 0 auto; height: 30px; border: 1px solid #e5e5e5; padding-left: 10px;}
.settle button{ background: #f00; border: 0; color: #fff; width: 80%; margin: 0 auto; margin-top: 10px; display: block; height: 30px; line-height: 30px;}
.settle p{ padding: 10px 15px; width: 80%; display: block; margin: 0 auto;}
.settle span{ color: #f00;}
.info{ padding: 0 15px;}
.info div{ padding: 10px 0;}
.info span{ width: 20%; display: inline-block;}
.info input{ border: 1px solid #e5e5e5; height: 25px; padding-left: 5px;}
.info button{ background: #f00; border: 0; color: #fff; width: 80%; margin: 0 auto; margin-top: 10px; display: block; height: 30px; line-height: 30px;}
</style>



// WEBPACK FOOTER //
// src/pages/settle_account/components/List.vue